import { createElement } from 'react';

import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import { AiLibraryClient, aiLibraryApiRef } from './api';
import { rootRouteRef } from './routes';

const aiLibraryApi = ApiBlueprint.make({
  name: 'ai-library',
  params: defineParams =>
    defineParams({
      api: aiLibraryApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiLibraryClient({ discoveryApi, fetchApi }),
    }),
});

const aiLibraryPage = PageBlueprint.make({
  name: 'ai-library',
  params: {
    path: '/ai-library',
    title: 'AI Library',
    icon: createElement(AutoAwesomeIcon),
    routeRef: rootRouteRef,
    loader: async () => {
      const { AiLibraryPage } = await import('./components/AiLibraryPage');
      return createElement(AiLibraryPage);
    },
  },
});

export const aiLibraryPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'ai-library-frontend',
  extensions: [aiLibraryApi, aiLibraryPage],
  routes: { root: rootRouteRef },
});
